import React from "react";
//import localize, { LocKeys } from "../../../constants/localizations";
import IconWrapper from "../../icons/IconWrapper";
import EditPenIcon from "../../icons/actions/EditPenIcon";

const EditButton = ({
	onClick,
	wrapperClasses = "",
	visibility = true,
	disabled = false,
	"data-testid": dataTestId,
}) => {
	return (
		<button
			disabled={disabled}
			type="button"
			onClick={(e) => onClick(e)}
			data-testid={dataTestId || "edit-button"}
			className={`btn btn--icon--solo btn--tertiary border-none bg-none p-s ${wrapperClasses} ${
				visibility ? "" : "visibility-hidden "
			}`}
		>
			<IconWrapper size="24" icon={<EditPenIcon iconClass="d-flex" />} />
		</button>
	);
};

export default EditButton;
